import { getCampaignEntity, FORM_MODES } from 'modules/campaigns/config';
import { IS_CREATIVE_LIBRARY } from 'modules/campaigns/hooks/useIsCreativeLibrary';
import { generateCampaignEditorPath } from 'modules/campaigns/services/utils';
import { mergeQueryParams } from 'modules/taboola-common-frontend-modules/query-params';
import { dimensionSelector, selectedAccountSelector } from 'selectors';

const duplicateCampaign = (rowData, navigate) => (_, getState) => {
    const { accountName, isCreativeLibrary } = rowData;
    const state = getState();
    const { accountId: selectedAccountId } = selectedAccountSelector(state);
    const dimension = dimensionSelector(state);
    const accountId = accountName || selectedAccountId;
    const entity = getCampaignEntity(rowData);
    // TODO: should take "rowData.id" in a generic way, so if the name of the field changes we wont need to change the code. Example: rowData[FIELDS.ID.field].
    const duplicateCampaignPath = generateCampaignEditorPath({
        mode: FORM_MODES.DUPLICATE,
        accountId,
        campaignId: rowData.id,
        dimension,
        entity,
    });

    const pathWithIsCreativeLibrary = `${duplicateCampaignPath}${mergeQueryParams('', {
        [IS_CREATIVE_LIBRARY]: isCreativeLibrary,
    })}`;

    navigate(pathWithIsCreativeLibrary);
};

export default duplicateCampaign;
